/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  itemDetail: false,
  // update
  updateSuccessful: false,
  updateLoading: false,
  updateError: false,
};

/* eslint-disable default-case, no-param-reassign */
const communicationNewMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      // Update for Single Element
      case UPDATE_COMMUNICATION:
        draft.updateLoading = true;
        draft.updateError = false;
        draft.updateSuccessful = false;
        draft.itemDetail = action.itemDetail;
        break;

      case UPDATE_COMMUNICATION_SUCCESS:
        draft.updateSuccessful = true;
        draft.updateLoading = false;
        draft.updateError = false;
        draft.itemDetail = {...state.itemDetail, ...action.itemDetail};
        break;

      case UPDATE_COMMUNICATION_ERROR:
        draft.updateError = action.updateError;
        draft.updateLoading = false;
        draft.updateSuccessful = false;
        break;
    }
  });

export default communicationNewMobileReducer;
